<template>
    <div class="fullname safe-distance-top">
        <div class="fullname_top">
            <van-icon
                style="position: absolute; left: 10px"
                size="25"
                name="arrow-left"
                @click="to()"
            />
            <div class="my">民族</div>
            <div class="determine" @click="determine">确定</div>
        </div>
        <div class="fullname_bottm">
            <van-cell-group style="border-radius: 8px">
                <van-field v-model="nation" placeholder="请输入民族" maxlength="20" ref="input">
                    <template #button>
                        <van-button size="small" style="border: none"
                            >{{ nation ? nation.length : "0" }}/20</van-button
                        >
                    </template></van-field
                >
            </van-cell-group>
        </div>
        <div class="prompt">请填写真实民族，认证通过后无法修改</div>
    </div>
</template>

<script>
import { Toast } from "vant";
export default {
    name: "fullname",
    data() {
        return {
            disabled: false,
            nation: "",
            obj: {},
            key: "",
        };
    },
    created() {
        // 回显
        // this.obj = JSON.parse(sessionStorage.getItem("scholarUserInfo"));
        // this.key = this.$route.query.nation.split(".");
        // this.nation = this.obj[this.key[0]][this.key[1]];

        // if (JSON.parse(sessionStorage.getItem("scholarUserInfos"))) {
        this.obj = JSON.parse(sessionStorage.getItem("scholarUserInfos"));

        this.nation = JSON.parse(sessionStorage.getItem("scholarUserInfos")).userInfo.nation;
        // this.obj = JSON.parse(sessionStorage.getItem("scholarUserInfos"));
        // }
        //  else {
        //   this.nation = JSON.parse(
        //     sessionStorage.getItem("scholarUserInfo")
        //   ).userInfo.nation;
        //   this.obj = JSON.parse(sessionStorage.getItem("scholarUserInfo"));
        // }
        // 聚焦
        this.$nextTick(() => {
            this.$refs.input.focus();
        });
    },
    methods: {
        to() {
            window.history.go(-1);
        },
        determine() {
            // let arr = sessionStorage.setItem("scholarUserInfo");

            // this.key = this.$route.query.nation.split(".");

            // this.obj[this.key[0]][this.key[1]] = this.nation;
            // console.log(this.obj, "11");
            if (this.nation.length == 0) {
                Toast("不能为空");
            } else {
                this.obj.userInfo.nation = this.nation;

                sessionStorage.setItem("scholarUserInfos", JSON.stringify(this.obj));

                this.$router.push("information");
            }

            // console.log(arr);
            // this.$router.push("information");
        },
    },
};
</script>

<style lang="scss" scoped>
.fullname {
    width: 100vw;
    min-height: 100vh;
    overflow: hidden;
    background: #f5f5f5;

    .fullname_top {
        height: 44px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #fff;
        line-height: 44px;
        align-content: center;
        position: relative;

        .my {
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            background: #fff;
            text-align: center;
        }

        .determine {
            font-size: 15px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            position: absolute;
            right: 15px;
        }
    }

    .fullname_bottm {
        width: 94%;
        margin: 12px auto;
        background: #fff;
        border-radius: 8px;

        .van-field {
            border-radius: 8px;
        }
    }

    .prompt {
        width: 94%;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        margin: 0 auto;
    }
}
</style>
